<template>
  <div class="box">
    <el-form
      ref="formRef"
      label-width="100px"
      :model="form"
      :rules="rules"
      hide-required-asterisk
      @submit.native.prevent
      size="small"
    >
      <div class="content">
        <el-form-item label="患者姓名" prop="username">
          <el-input
            v-model="form.username"
            clearable
            placeholder="请输入患者姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCardNo">
          <el-input
            v-model="form.idCardNo"
            @change="idCardNoChange"
            clearable
            placeholder="请输入身份证号"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-radio-group v-model="form.gender">
            <template v-for="(item, index) in range">
              <el-radio :key="index" :label="item.value">{{
                item.label
              }}</el-radio>
            </template>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄" prop="age">
          <el-input
            v-model="form.age"
            clearable
            placeholder="请输入年龄"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNo">
          <el-input
            v-model="form.phoneNo"
            clearable
            placeholder="请输入微信授权手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="医保卡号" prop="medicalCardNo">
          <el-input
            v-model="form.medicalCardNo"
            clearable
            placeholder="请输入医保卡号"
          ></el-input>
        </el-form-item>
        <el-form-item label="出生日期" prop="birth">
          <el-date-picker
            v-model="form.birth"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="身高" prop="height">
          <el-input
              v-model="form.height"
              clearable
              placeholder="请输入身高"
          ></el-input>
        </el-form-item>
        <el-form-item label="体重" prop="weight">
          <el-input
              v-model="form.weight"
              clearable
              placeholder="请输入体重"
          ></el-input>
        </el-form-item>
        <el-form-item label="学历" prop="education">
          <el-select
              v-model="form.education"
              clearable
              placeholder="请选择学历"
          >
            <el-option
                v-for="item in educationList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="基础病" prop="complication">
          <el-select
              v-model="form.complication"
              multiple
              clearable
              placeholder="请选择基础病"
          >
            <el-option
                v-for="item in complicationList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey" />
          </el-select>
<!--          <el-input
              v-model="form.complication"
              clearable
              placeholder="请输入基础病"
              maxlength="50"
          ></el-input>-->
        </el-form-item>
        <el-form-item label="患者分组" prop="groupId">
          <el-select
            v-model="form.groupId"
            disabled
            @change="groupChange"
            clearable
            placeholder="请选择管理医生"
          >
            <el-option
              v-for="item in groupList"
              :key="item.groupId"
              :label="item.name"
              :value="item.groupId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="管理医生" prop="docId">
          <el-select
            v-model="form.docId"
            clearable
            placeholder="请选择管理医生"
          >
            <el-option
              v-for="item in doctor_list"
              :key="item.id"
              :label="item.docName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div class="title">检查信息</div>
        <el-form-item label="检查时段" prop="timeQueue">
          <el-radio-group v-model="form.timeQueue">
            <template v-for="(item, index) in inspectionPeriod">
              <el-radio :key="index" :label="item.value">{{
                  item.label
                }}</el-radio>
            </template>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="检查类型">
          <el-select
            v-model="form.checkItem"
            @clear="clearSelect"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in checkItemList"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检查时间">
          <el-date-picker
            v-model="form.checkDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择检查时间"
            :picker-options="checkDateOptions">
          </el-date-picker>
        </el-form-item>
      </div>
      <el-form-item>
        <div class="but">
          <el-button @click="onSubmit" type="primary">保存</el-button>
          <el-button @click="go_back">取消</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { IdCard } from "@/utils/IdCard";
import dayjs from "dayjs";

export default {
  name: "bowelPreparationDetails",
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          console.log( time.getTime());

          return time.getTime() <= Date.now();
        },
      },
      form: {
        id: "",
        username: "",
        idCardNo: "",
        medicalCardNo: "",
        birth: "",
        gender: "",
        age: "",
        phoneNo: "",
        docId: "",
        checkDate: "",
        groupId: "",
        height: "",
        weight: "",
        education: "",
        complication: "",
        timeQueue: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入患者姓名", trigger: "blur" },
        ],
        idCardNo: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证号不合法",
          },
        ],
        medicalCardNo: [
          // { required: true, message: '请输入医保卡号', trigger: 'blur' },
        ],
        birth: [{ required: true, message: "请选择出生日期", trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
        age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
        phoneNo: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9]))\d{8}$/,
            message: "手机号不正确",
          },
        ],
        docId: [{ required: true, message: "请输入管理医生", trigger: "blur" }],
        groupId: [
          { required: true, message: "请选择患者分组", trigger: "blur" },
        ],
        // checkItem: [
        //     { required: true, message: '请选择检查类型', trigger: 'blur' },
        // ],
        // checkDate: [
        //     { required: true, message: '请选择检查时间', trigger: 'blur' },
        // ],
      },
      checkDateOptions: {
        disabledDate(time) {
          // 禁用今天及之前的日期
          const today = dayjs().startOf('day');
          const selectDate = dayjs(time);
          return selectDate.isBefore(today, 'day') || selectDate.isSame(today, 'day');
        }
      },
      groupList: [],
      complicationList: [],
      educationList: [],
      doctor_list: [],
      checkItemList: [],
      range: [
        {
          value: "1",
          label: "男",
        },
        {
          value: "0",
          label: "女",
        },
      ],
      inspectionPeriod: [
        {
          value: "0",
          label: "上午",
        },
        {
          value: "1",
          label: "下午",
        },
      ]
    };
  },
  computed: {
    patientId() {
      return this.$route.query.id || "";
    },
    docId() {
      return this.$route.query.docId || "";
    },
    groupId() {
      return this.$route.query.groupId || "";
    },
    leaderId() {
      return this.$route.query.leaderId || "";
    },
    groupDisabled() {
      let flag = true;
      if (
        this.leaderId === this.$store.state.doctor_id ||
       this.$store.state.roleName == '超级管理员' || this.$store.state.roleName == '管理员'
      ) {
        flag = false;
      }
      return flag;
    },
  },
  async created() {
    // this.doctorlistFn();
    await this.getCheckItemList();
    await this.getGroupList();
    await this.getEducationList();
    await this.getComplicationList();
    let patientId = this.$route.query.id;
    let doc_id = this.$route.query.docId;
    if (patientId) {
      this.get_details(patientId, doc_id);
    } else {
      await this.getDoctorList(this.groupId);
      this.form.groupId = this.groupId;
    }
  },
  mounted() {},
  methods: {
    // 获取急出病字典
    async getComplicationList() {
      try {
        const res = await this.$get("base/dict/disease");
        if (!res) return false;
        const { data } = res;
        this.complicationList = data;
      }catch (e) {
        console.error(`获取基础病字典失败`, e);
      }
    },
    async getEducationList() {
      try {
        const res = await this.$get("base/dict/hh_education");
        if (!res) return false;
        const { data } = res;
        this.educationList = data;
      }catch (e) {
        console.error(`获取学历字典失败`, e);
      }
    },
    clearSelect() {
      this.form.checkDate = "";
    },
    groupChange(e) {
      this.form.docId = "";
      this.getDoctorList(e);
    },
    async getGroupList() {
      try {
        const res = await this.$get("group/list", {
          docId: this.$store.state.doctor_id,
        });
        if (!res) return false;
        const { data } = res;
        this.groupList = data;
      } catch (e) {
        console.error(e);
      }
    },
    async getDoctorList(e) {
      try {
        const res = await this.$get("gp/getNewDoctorList", {
          groupId: e,
        });
        if (!res) return false;
        const { data } = res;
        this.doctor_list = data;
      } catch (e) {
        console.error(e);
      }
    },
    async getCheckItemList() {
      try {
        const res = await this.$get("base/dict/checkItem");
        if (!res) return false;
        const { data } = res;
        this.checkItemList = data;
      } catch (e) {
        console.error(e);
      }
    },
    get_details(patientId, docId) {
      this.$get(`colondoc/patient`, {
        patientId,
        docId,
      }).then(async (res) => {
        if (res) {
          const { data } = res;
          await this.getDoctorList(data.groupId);
          if (data.complication) {
            data.complication = data.complication.split(",");
          }
          this.form = data;
        }
      });
    },
    onSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          console.log(this.form);
          let obj = {...this.form};
          if (obj.complication && obj.complication.length > 0) {
            obj.complication = obj.complication.join(",");
          }else {
            obj.complication = "";
          }
          // this.form.checkItem=this.form.checkItem==3?'':this.form.checkItem;
          this.$post("colondoc/save", obj).then((res) => {
            if (res) {
              this.$message.success("添加成功");
              this.go_back();
            }
          });
        }
      });
    },
    idCardNoChange(e) {
      this.$refs.formRef.validateField("idCardNo", (valid) => {
        if (!valid) {
          this.form.gender = IdCard(e, 2);
          this.form.age = IdCard(e, 3);
          this.form.birth = IdCard(e, 1);
        } else {
          this.form.gender = "";
          this.form.age = "";
          this.form.birth = "";
        }
      });
    },
    go_back() {
      this.$router.go(-1);
    },
    doctorlistFn() {
      this.$get("colondoc/doctorlisrt").then((res) => {
        if (res) {
          let data_ = res.data;
          this.doctor_list = data_;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding: 24px;
  background: #ffffff;
}

.el-form {
  .content {
    width: 30%;
  }
  .el-select {
    width: 100%;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
  .but {
    display: flex;
    justify-content: flex-end;
  }
}
.title {
  font-weight: 700;
  font-size: 20px;
  color: #606266;
  padding-left: 30px;
  margin-bottom: 20px;
}
</style>
